import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import DdiList from "./ddi_list";
import { DDI_GetGroup } from "data/ddis";

const DdiGroup = ({ group, showHeader = true, patientControls = null, groupCategory = null }) => {
  const { t, i18n } = useTranslation();
  const [localGroup, setLocalGroup] = useState(group);

  useEffect(() => {
    if (typeof group === "string") {
      setLocalGroup(DDI_GetGroup(group));
    } else if (group?.categoryKey) {
      setLocalGroup(group);
    } else if (group?.category) {
      setLocalGroup(group);
    } else {
      setLocalGroup(null);
    }
  }, [group]);

  const sortedMedications = useMemo(() => {
    if (!localGroup?.medications) return [];
    return [...localGroup.medications].sort((a, b) => {
      const nameA = a?.nameKey ? t("ddis_common:" + a.nameKey) : a?.name || "";
      const nameB = b?.nameKey ? t("ddis_common:" + b.nameKey) : b?.name || "";
      return nameA.localeCompare(nameB);
    });
  }, [localGroup?.medications, t]);

  return (
    <div className="ddi-group">
      {showHeader && <h3>{localGroup?.categoryKey ? t("ddis_common:" + localGroup.categoryKey) : localGroup?.category}</h3>}
      <div>
        <DdiList list={sortedMedications} patientControls={patientControls} groupCategory={groupCategory} />
      </div>
    </div>
  );
};

export default DdiGroup;
